import { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { BiChevronRight } from "react-icons/bi";

function SimpleHeader(props) {
  const [redirect, setRedirect] = useState(false);
  return (
    <header
      className={`row mx-0 px-3 py-2 header position-sticky bg-white shadow-sm ${
        !props.bgNone && "bg-main-light"
      }`}
      style={{ top: "0", right: "0", left: "0", zIndex: "99" }}
    >
      {redirect && <Navigate push to={props.path} />}
      {!props.disableBackButton && (
        <div
          className="col-auto px-0 align-self-center text-main"
          onClick={() =>
            props.path
              ? setRedirect(true)
              : window.history.length > 1
              ? window.history.back()
              : setRedirect(true)
          }
        >
          <div className="ps-2">
            <BiChevronRight size={30} />
          </div>
        </div>
      )}
      {props.text && (
        <div
          className={`col${
            props.status && props.status !== "active" ? "-auto ps-3" : ""
          } align-self-center text-end px-0`}
        >
          <h1 className="fs-6 text-main fw-bolder mb-0">{props.text}</h1>
        </div>
      )}
      {props.logo && (
        <div className="col-auto px-1 align-self-center">
          <Link to="/">
            <img
              alt="logo"
              width="90"
              className=""
              src={require("../../assets/images/iran-app-logo.svg").default}
            />
          </Link>
        </div>
      )}
      <div className="col text-start px-1 align-self-center">
        <Link
          to="/my-ticket-list"
          style={{ marginLeft: "40px" }}
          className="d-inline-block"
        >
          <button className="btn rounded40 px-3 fs-7 bg-main-grad border-0 text-white">
            خریدهای من
          </button>
        </Link>
      </div>
    </header>
  );
}

export default SimpleHeader;
